import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button } from 'atoms/buttons/Button';
import { Vertical } from 'atoms/layout/flex';
import { BodyM, HeadlineS } from 'atoms/typography';
import { Dialog } from 'components/dialog';
import { useIntlContext } from 'contexts/intl';
import { AcceptedCurrenciesValue } from 'hooks/useAcceptedCurrencies';

import { messages } from '../messages';

const Content = styled(Vertical).attrs({ gap: 3, center: true })`
  text-align: center;
  padding: var(--triple-unit);
`;

const Text = styled(Vertical).attrs({ gap: 2 })``;

const Actions = styled(Vertical)`
  width: 100%;
`;

type Props = {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  value?: AcceptedCurrenciesValue;
};

export const ConfirmationDialog = ({
  open,
  value,
  onConfirm,
  onCancel,
}: Props) => {
  const { formatMessage } = useIntlContext();
  const displayValue = () => {
    switch (value) {
      case AcceptedCurrenciesValue.BOTH:
        return formatMessage(messages.cashAndEth);
      case AcceptedCurrenciesValue.FIAT:
        return formatMessage(messages.fiat);
      case AcceptedCurrenciesValue.ETH:
      default:
        return formatMessage(messages.eth);
    }
  };
  return (
    <Dialog open={open} maxWidth="xs" fullWidth onClose={onCancel} hideHeader>
      <Content>
        <Text>
          <HeadlineS as="h5" bold color="var(--c-white)">
            <FormattedMessage
              id="Settings.acceptedCurrencies.confirmation.title"
              defaultMessage="Are you sure?"
            />
          </HeadlineS>
          <BodyM color="var(--c-white)">
            <FormattedMessage
              id="Settings.acceptedCurrencies.confirmation.description"
              defaultMessage="This will only apply to future card listings, your current listings will follow previous payment settings."
            />
          </BodyM>
        </Text>
        <Actions>
          <Button fullWidth color="primary" size="medium" onClick={onConfirm}>
            <FormattedMessage
              id="Settings.acceptedCurrencies.confirmation.confirm"
              defaultMessage="Yes, update to {value}"
              values={{
                value: displayValue(),
              }}
            />
          </Button>
          <Button fullWidth color="tertiary" size="medium" onClick={onCancel}>
            <FormattedMessage
              id="Settings.acceptedCurrencies.confirmation.cancel"
              defaultMessage="No, go back"
            />
          </Button>
        </Actions>
      </Content>
    </Dialog>
  );
};
